// Scripts for the general centered content component
import '../../../../styles/src/components/general/centered-content.scss';
